var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M1026,4580a49.842,49.842,0,1,1,19.463-3.929A49.68,49.68,0,0,1,1026,4580Zm-9-68a1.673,1.673,0,0,0-.376.042l-7.313,1.687a1.681,1.681,0,0,0-1.308,1.645A32.662,32.662,0,0,0,1040.625,4548a1.679,1.679,0,0,0,1.645-1.308l1.689-7.312a1.711,1.711,0,0,0-.985-1.94l-7.876-3.376a1.686,1.686,0,0,0-1.968.486l-3.489,4.26a26.131,26.131,0,0,1-12.459-12.458l4.261-3.488a1.689,1.689,0,0,0,.485-1.969l-3.375-7.875A1.7,1.7,0,0,0,1017,4512Z",
    transform: "translate(-976 -4480)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhoneIcon);
export default __webpack_public_path__ + "static/media/contact-phone-icon.d6b3ab835863a5a8ad61da3a8d5cb2c2.svg";
export { ForwardRef as ReactComponent };